import { store } from '@/shared/store-tmp';

export const getEmailType = () => {
  const { user } = store.getState();

  return user?.email_type;
};
